import { useStore } from '@/store/useStore';
import TraditionalHome from '@/components/home/TraditionalHome';
import AIDiscoveryHome from '@/components/home/AIDiscoveryHome';

export default function HomePage() {
  const aiMode = useStore(state => state.aiMode);
  const toggleAIMode = useStore(state => state.toggleAIMode);

  return (
    <div className="relative">
      {/* Mode Toggle */}
      <div className="sticky top-16 z-40 bg-warm-dark border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-slate">
                {aiMode ? 'AI Discovery Mode' : 'Traditional Browse'}
              </h2>
              <p className="text-sm text-gray-600">
                {aiMode
                  ? 'Describe what you need and let AI find the perfect gear'
                  : 'Browse our curated collection of outdoor equipment'}
              </p>
            </div>

            <button
              onClick={toggleAIMode}
              className="relative inline-flex h-12 rounded-full bg-gray-200 overflow-hidden transition-colors focus:outline-none focus:ring-2 focus:ring-amber focus:ring-offset-2"
            >
              <div
                className={`flex items-center px-6 py-3 font-semibold transition-all duration-300 ${
                  !aiMode ? 'bg-forest text-white' : 'bg-transparent text-gray-600 hover:text-gray-800'
                }`}
              >
                Traditional
              </div>
              <div
                className={`flex items-center px-6 py-3 font-semibold transition-all duration-300 ${
                  aiMode ? 'bg-forest text-white' : 'bg-transparent text-gray-600 hover:text-gray-800'
                }`}
              >
                AI Discovery
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      {aiMode ? <AIDiscoveryHome /> : <TraditionalHome />}
    </div>
  );
}
